export const LINKS = {
  github: 'https://github.com/charlesnchr/riddler-bench',
  readme: 'https://github.com/charlesnchr/riddler-bench#readme',
  dataset: 'https://github.com/charlesnchr/riddler-bench/tree/main/data',
}; 